import {
  Box,
  Button,
  FormControlLabel,
  IconButton,
  Modal,
  Radio,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { Postrequestcall } from "../../request/Postrequest";
import {
  GET_SURVEY_QUIZ,
  GET_SURVEY_DATE_NEVER,
  SAVE_SURVEY_ANSWERS
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { Getrequestcall } from "../../request/Getrequest";
import { English } from "../../constant/EnglishFallback";
import { ArrowBack } from "@mui/icons-material";

const SurveyQuizModal = ({ open, onClose, setSurveyModal }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  let currentUserId = loginData?.userInformation?.UserId;
  const [quiz, setQuiz] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    TEXT_PLEASE_SELECT_THE_OPTION = English?.Survey_Dashboard_Web?.TEXT_PLEASE_SELECT_THE_OPTION,
    TEXT_THIS_IS_REQUIRED = English?.Survey_Dashboard_Web?.TEXT_THIS_IS_REQUIRED,
    BUTTON_SAVE = English?.Survey_Dashboard_Web?.BUTTON_SAVE
  } = multiLanguageData?.Survey_Dashboard_Web || {};

  useEffect(() => {
    fetchQuiz();
  }, []);

  const fetchQuiz = async () => {
    setIsLoading(true);
    try {
      const fetchQuestionObj = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: Number(currentUserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{}],
        isLoading: true
      };
      const questions = await Postrequestcall(
        GET_SURVEY_QUIZ,
        fetchQuestionObj,
        loginData?.accessToken
      );
      let data = questions?.data?.data?.map((item) => {
        if (item.questionType == "Select") {
          let array = item.answerList?.map((answer) => {
            return {
              ...answer,
              isChecked: false
            };
          });
          return {
            ...item,
            answerList: array
          };
        }
        if (item.questionType == "Multiline") {
          return { ...item, givenAnswer: "" };
        }
      });
      setQuiz(data);
    } catch (error) {
      console.log("fetchQuiz-> Error When Fetching BI Quizes: " + error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckBoxChange = (e, index, index1) => {
    let temp = [...quiz];
    temp[index].answerList?.map((item, a) => {
      if (a == index1) {
        item.isChecked = true;
      } else item.isChecked = false;
    });
    setQuiz(temp);
  };

  const handleTextChange = (e, index) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    let temp = [...quiz];
    temp[index] = {
      ...temp[index],
      givenAnswer: inputValue
    };
    setQuiz(temp);
  };

  const saveTheData = async () => {
    setDisableButton(true);
    let temp = [...quiz];
    let data = temp?.map((item) => {
      if (item.questionType == "Select") {
        return {
          Id: 0,
          BIQuizQuestionId: item.id,
          BIQuizAnswer: item.answerList.find((x) => x.isChecked)?.biQuizQuestionId,
          RecordStatusId: 1,
          ModifiedBy: Number(currentUserId)
        };
      }
      if (item.questionType == "Multiline") {
        return {
          Id: 0,
          BIQuizQuestionId: item.id,
          BIQuizAnswer: item.givenAnswer,
          RecordStatusId: 1,
          ModifiedBy: Number(currentUserId)
        };
      }
    });

    try {
      const saveListObj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: data
      };
      await Postrequestcall(SAVE_SURVEY_ANSWERS, saveListObj, loginData?.accessToken);
      await Getrequestcall(`${GET_SURVEY_DATE_NEVER}/${currentUserId}/5`, loginData?.accessToken);
      onClose();
    } catch (error) {
      console.log("saveTheData-> Error When Saving Survey Data: " + error);
    }
  };

  const handleSave = () => {
    // validation
    let temp = [...quiz];
    let sample = [];
    let isValidcount = 0;
    temp?.map((item, index) => {
      if (item?.questionType == "Select") {
        let temp = item?.answerList?.map((item) => item?.isChecked == true);

        let check = temp.some((item) => item == true);
        if (!check) {
          sample.push({
            ...quiz[index],
            checkValidation: true
          });
          isValidcount += 1;
        } else {
          sample.push({
            ...quiz[index],
            checkValidation: false
          });
        }
      }
      if (item?.questionType == "Multiline") {
        if (item?.givenAnswer == "") {
          sample.push({
            ...quiz[index],
            checkValidation: true
          });
          isValidcount += 1;
        } else {
          sample.push({
            ...quiz[index],
            checkValidation: false
          });
        }
      }
    });

    setQuiz(sample);

    if (isValidcount == 0) {
      saveTheData();
    } else {
      console.log("handleSave-> Error In Saving Data");
    }
  };

  return (
    <Modal open={open} closeAfterTransition>
      <Box
        className="user-modal-responsive"
        sx={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          position: "relative"
        }}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <IconButton
                disabled={disableButton}
                onClick={() => {
                  setSurveyModal(true);
                  onClose();
                }}>
                <ArrowBack />
              </IconButton>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                px: 3
              }}>
              {quiz?.map((item, index) => (
                <Box key={index} sx={{ mb: 3 }}>
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>{item?.question}</Typography>

                  {item.questionType === "Select" && (
                    <Stack spacing={1}>
                      {item.answerList?.map((answer, index1) => (
                        <FormControlLabel
                          key={index1}
                          checked={answer.isChecked}
                          control={
                            <Radio
                              color="primary"
                              onChange={(e) => handleCheckBoxChange(e, index, index1)}
                            />
                          }
                          label={answer.answer}
                        />
                      ))}
                    </Stack>
                  )}

                  {item.questionType === "Select" && item.checkValidation && (
                    <Typography sx={{ color: "red" }}>{TEXT_PLEASE_SELECT_THE_OPTION}</Typography>
                  )}

                  {item.questionType === "Multiline" && (
                    <TextField
                      error={item.checkValidation}
                      fullWidth
                      multiline
                      rows={1}
                      label="Answer"
                      helperText={item.checkValidation ? TEXT_THIS_IS_REQUIRED : ""}
                      onChange={(e) => handleTextChange(e, index)}
                      value={item.givenAnswer}
                    />
                  )}
                </Box>
              ))}
            </Box>
            <Box sx={{ pt: 2, borderTop: "1px solid #eee" }}>
              <Button
                disabled={disableButton}
                variant="contained"
                onClick={handleSave}
                loading={disableButton}>
                {BUTTON_SAVE}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default SurveyQuizModal;
